import actions from "./actions";

const initState = {
  isSubmitting: false,
  submissionFailed: undefined,
  token: null,
};

export default function (state = initState, action) {
  switch (action.type) {
    case actions.RETRIEVE_LEADMARKET_LEAD_TOKEN_START:
      return {
        ...state,
        isSubmitting: true,
      };
    case actions.RETRIEVE_LEADMARKET_LEAD_TOKEN_FAILED:
      return {
        ...state,
        token: "",
        isSubmitting : false,
        submissionFailed: true
      };
    case actions.RETRIEVE_LEADMARKET_LEAD_TOKEN_SUCCESS:
      return {
        ...state,
        isSubmitting : false,
        token : action.payload,
      };
    default:
      return state;
  }
}
